import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { RedeemItem } from '@mommy/models/vender.model';
import { UtilService } from '@mommy/services/util.service';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-add-exchange-product-modal',
  templateUrl: './add-exchange-product-modal.page.html',
  styleUrls: ['./add-exchange-product-modal.page.scss'],
})
export class AddExchangeProductModalPage implements OnInit {
  type: 'cart' | 'buy' = 'cart';
  quantity = 1;
  _total_point = 0;

  redeemItem: RedeemItem;
  customer_name: string;
  customer_phone: string;
  customer_addr: string;

  constructor(
    public modalController: ModalController,
    public navParams: NavParams,
    private store: Store,
    private util: UtilService
  ) {
    this.redeemItem = this.navParams.get('redeemItem');
    this._total_point = this.redeemItem.point * this.quantity;
    console.log('redeemItem', this.redeemItem);
  }

  ngOnInit() {}

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  quantityChange(event) {
    console.log('quantityChange', event);
    this.quantity = event;
    this._total_point = this.redeemItem.point * this.quantity;
  }

  // 規格變更後需要連動顯示價格
  // specChange(event) {
  //   console.log('specChange', event);
  //   this._price = event.detail.value.price;
  //   this._pricing = event.detail.value.pricing;
  //   this._specQuantity = event.detail.value.quantity;
  //   this._maxRedeemedPoints = event.detail.value.maxRedeemedPoints;
  // }

  async addCart() {
    // console.log('addCart item', this.selectedSpec);
    // console.log('addCart quantity', this.quantity);

    if (!this.customer_name) {
      this.util.showToast('請輸入姓名', undefined, undefined, undefined, 'top');
      return;
    }

    if (!this.customer_phone) {
      this.util.showToast(
        '請輸入聯絡電話',
        undefined,
        undefined,
        undefined,
        'top'
      );
      return;
    }

    if (!this.customer_addr) {
      this.util.showToast(
        '請輸入收貨地址',
        undefined,
        undefined,
        undefined,
        'top'
      );
      return;
    }

    if (this.quantity <= 0) {
      this.util.showToast('請選擇數量', undefined, undefined, undefined, 'top');
      return;
    }

    try {
      await this.util.showYNconfirm('', '確定要兌換嗎？');

      const redeem = {
        item_id: this.redeemItem.item_id,
        item_qty: this.quantity,
        customer_name: this.customer_name,
        customer_phone: this.customer_phone,
        customer_addr: this.customer_addr,
      };

      this.modalController.dismiss({ redeem });
    } catch (error) {
      console.log('user cancel', error);
    }
  }
}
